import React, { useState, useEffect } from "react";
import nextarrow from "../assets/images/icons/next-arrow.svg";
import Dropdown from "../assets/images/icons/arrow-down.svg";
import global from "../assets/images/icons/green-global.png";
import dollar from "../assets/images/icons/dollar.svg";
import searchicon from "../assets/images/icons/search.png";
import visacardImg from "../assets/images/icons/visa.svg";
import mastercardImg from "../assets/images/icons/mastercard.svg";
import sellericon from "../assets/images/icons/becomeseller-menu.svg";
import paymentsuccess from "../assets/images/icons/Payment-success.svg";
import paymentfailed from "../assets/images/icons/retry-payment.svg";
import Retryicon from "../assets/images/icons/refresh-right-square.svg";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const BASE_URL = API_BASE_URL;

const GoLiveDonationgiftModal = ({
  isOpen,
  onClose,
  logo,
  closeIcon,
  streamId,
  streamDetails,
}) => {
  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();

  const [step, setStep] = useState(1); // 1 = Amount, 2 = Payment
  const [amount, setAmount] = useState(50);
  const [customAmount, setCustomAmount] = useState("");
  const [selectedCard, setSelectedCard] = useState("wallet"); // 'wallet' or card_id
  const [paymentStatus, setPaymentStatus] = useState("idle"); // idle, processing, success, failed
  const [walletBalance, setWalletBalance] = useState(0);
  const [savedCards, setSavedCards] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [activeTab, setActiveTab] = useState("donation"); // 'donation' | 'gift'
  const [gifts, setGifts] = useState([]);
  const [selectedGift, setSelectedGift] = useState(null);

  // Helper to get formatted date
  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };

  useEffect(() => {
    if (isOpen && streamId) {
      setStep(1);
      setPaymentStatus("idle");
      setActiveTab("donation");
      fetchDonationData();
      fetchGifts();
    }
  }, [isOpen, streamId]);

  const fetchGifts = async () => {
    try {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");
      const res = await fetch(`${BASE_URL}/live/gifts`, {
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
      });
      const data = await res.json();
      if (res.ok && data.success) {
        // Handle both { result: [...] } and { result: { gifts: [...] } } structures
        const giftsList = Array.isArray(data.result)
          ? data.result
          : data.result?.gifts || [];
        setGifts(giftsList);
      } else {
        // Mock if empty
        setGifts([
          {
            id: 1,
            name: "Heart",
            coinValue: 10,
            icon: "https://cdn-icons-png.flaticon.com/512/833/833472.png",
          },
          {
            id: 2,
            name: "Rose",
            coinValue: 50,
            icon: "https://cdn-icons-png.flaticon.com/512/740/740845.png",
          },
          {
            id: 3,
            name: "Diamond",
            coinValue: 100,
            icon: "https://cdn-icons-png.flaticon.com/512/616/616490.png",
          },
        ]);
      }
    } catch (err) {
      console.error("Error fetching gifts:", err);
      setGifts([
        {
          id: 1,
          name: "Heart",
          coinValue: 10,
          icon: "https://cdn-icons-png.flaticon.com/512/833/833472.png",
        },
        {
          id: 2,
          name: "Rose",
          coinValue: 50,
          icon: "https://cdn-icons-png.flaticon.com/512/740/740845.png",
        },
        {
          id: 3,
          name: "Diamond",
          coinValue: 100,
          icon: "https://cdn-icons-png.flaticon.com/512/616/616490.png",
        },
      ]);
    }
  };

  const fetchDonationData = async () => {
    try {
      setIsLoading(true);
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");

      // 1. Fetch Wallet Balance (Mocking based on typical endpoints or using bottom-sheet if available)
      // Since bottom-sheet might not be fully ready, let's try to fetch user wallet/cards if possible.
      // But let's try the documented endpoint first.
      const res = await fetch(
        `${BASE_URL}/live/${streamId}/donation/bottom-sheet`,
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        },
      );

      // If endpoint fails (404), we might fallback to mocking for UI demo as requested
      if (res.ok) {
        const data = await res.json();
        if (data.success) {
          setWalletBalance(data.result?.wallet_balance || 0);
          setSavedCards(data.result?.cards || []);
        }
      } else {
        // Fallback Mock for Demo purposes if API is not live yet
        console.warn("Donation bottom-sheet API failed, using mock data.");
        setWalletBalance(500);
        setSavedCards([
          {
            id: "mastercard",
            name: "Mastercard",
            last4: "5432",
            expiry: "12/20",
            img: mastercardImg,
          },
          {
            id: "visa",
            name: "Visa",
            last4: "4291",
            expiry: "12/20",
            img: visacardImg,
          },
        ]);
      }
    } catch (err) {
      console.error("Error fetching donation data:", err);
      // Fallback Mock
      setWalletBalance(500);
      setSavedCards([
        {
          id: "mastercard",
          name: "Mastercard",
          last4: "5432",
          expiry: "12/20",
          img: mastercardImg,
        },
        {
          id: "visa",
          name: "Visa",
          last4: "4291",
          expiry: "12/20",
          img: visacardImg,
        },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAmountSelect = (val) => {
    setAmount(Number(val));
    setCustomAmount("");
  };

  const handleCustomAmountChange = (e) => {
    setCustomAmount(e.target.value);
    setAmount(Number(e.target.value));
  };

  const handleDonate = async () => {
    if (!amount || amount <= 0) {
      toast.error("Please enter a valid amount");
      return;
    }

    try {
      setSubmitting(true);
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");

      let paymentMethodId = null;

      // ✅ Handle New Card Tokenization
      if (selectedCard === "new_card") {
        if (!stripe || !elements) {
          toast.error("Stripe is not loaded");
          setSubmitting(false);
          return;
        }
        const cardElement = elements.getElement(CardElement);
        const { error, paymentMethod } = await stripe.createPaymentMethod({
          type: "card",
          card: cardElement,
        });

        if (error) {
          console.error(error);
          toast.error(error.message);
          setSubmitting(false);
          return;
        }
        paymentMethodId = paymentMethod.id;
      }

      const payload = {
        amount: amount,
        payment_method: selectedCard === "wallet" ? "wallet" : "card",
        message: "Support from viewer",
      };

      // Only add card-specific fields if they exist (to avoid backend validation errors on null)
      if (selectedCard !== "wallet" && selectedCard !== "new_card") {
        payload.card_id = selectedCard;
      }
      // Temporarily removed payment_method_id as per user request to debug backend validation
      // if (paymentMethodId) {
      //   payload.payment_method_id = paymentMethodId;
      // }

      console.log("Processing Donation:", payload);

      const res = await fetch(`${BASE_URL}/live/${streamId}/donation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (res.ok && data.success) {
        // ✅ Handle Stripe Confirmation if client_secret is present
        if (data.result?.client_secret) {
          const confirmResult = await stripe.confirmCardPayment(
            data.result.client_secret,
          );
          if (confirmResult.error) {
            toast.error(confirmResult.error.message);
            setPaymentStatus("failed");
          } else if (
            confirmResult.paymentIntent.status === "succeeded" ||
            confirmResult.paymentIntent.status === "processing"
          ) {
            setPaymentStatus("success");
          }
        } else {
          setPaymentStatus("success");
        }
      } else {
        console.error("Donation failed:", data);
        setPaymentStatus("failed");
      }
    } catch (err) {
      console.error("Donation Error:", err);
      setPaymentStatus("failed");
    } finally {
      setSubmitting(false);
    }
  };

  const handleSendGift = async () => {
    if (!selectedGift) {
      toast.error("Please select a gift to send");
      return;
    }

    try {
      setSubmitting(true);
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");

      const payload = {
        giftId: selectedGift.id,
        coinValue: selectedGift.coinValue,
      };

      console.log("Sending Gift:", payload);

      const res = await fetch(`${BASE_URL}/live/${streamId}/gift`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (res.ok && data.success) {
        setPaymentStatus("success");
      } else {
        console.error("Gift failed:", data);
        setPaymentStatus("failed");
      }
    } catch (err) {
      console.error("Gift Error:", err);
      setPaymentStatus("failed");
    } finally {
      setSubmitting(false);
    }
  };

  if (!isOpen) return null;

  // Render Logic
  const renderSuccessOrFailure = () => (
    <div className="flex flex-col items-center justify-center py-12 text-center animate-fadeIn px-10">
      <img
        src={paymentStatus === "failed" ? paymentfailed : paymentsuccess}
        className="w-24 h-24 mb-4"
        alt="Status"
      />
      <h2 className="text-2xl font-bold text-black my-5">
        {paymentStatus === "failed"
          ? "Payment Failed"
          : "Thank You for Supporting!"}
      </h2>
      <div className="my-5">
        {paymentStatus === "success" && (
          <p className="text-[#474747] text-[14px] font-medium max-w-md mx-auto">
            Your gift has been successfully sent to{" "}
            {streamDetails?.user?.username || "Creator"}
          </p>
        )}
        {paymentStatus === "failed" && (
          <p className="text-[#474747] text-[14px] font-medium max-w-md mx-auto">
            Unfortunately, we couldn't process your payment.
          </p>
        )}

        <div className="mt-4">
          <p className="text-[#474747] text-[14px] font-medium max-w-md">
            Total Payment
          </p>
          <h3 className="text-[#121212] text-4xl max-w-md font-semibold">
            {activeTab === "donation"
              ? `$${amount}`
              : selectedGift
                ? `🪙 ${selectedGift.cost || selectedGift.coinValue}`
                : "-"}
          </h3>
          <p className="text-[#121212] text-[13px] font-[500] max-w-md">
            {formatDate(new Date())}
          </p>
        </div>
      </div>

      <div className="mx-auto my-5 p-4 w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="border border-[#EDEDED] rounded-xl p-5 bg-white text-left min-w-lg">
            <p className="text-[12px] text-[#707070] mb-1">Sender Name</p>
            <p className="text-[13px] font-[400] text-[#121212] ">
              {sessionStorage.getItem("username") || "You"}
            </p>
          </div>
          <div className="border border-[#EDEDED] rounded-xl p-5 bg-white text-left min-w-lg">
            <p className="text-[12px] text-[#707070] mb-1">Payment Method</p>
            <p className="text-[13px] font-[400] text-[#121212] text-left">
              {selectedCard === "wallet" ? "Wallet" : "Credit Card"}
            </p>
          </div>
        </div>
      </div>

      <button
        onClick={paymentStatus === "failed" ? handleDonate : onClose}
        className={`text-white px-12 py-3 rounded-full font-semibold transition-colors ${
          paymentStatus === "failed"
            ? "bg-red-600 hover:bg-red-700"
            : "bg-[#095228] hover:bg-[#07401f]"
        }`}
      >
        {paymentStatus === "failed" && (
          <img
            src={Retryicon}
            alt="RetryIcon"
            className="w-5 h-5 mr-2 inline"
          />
        )}
        {paymentStatus === "failed"
          ? "Retry Payment"
          : "Continue Watching Live"}
      </button>
    </div>
  );

  return (
    <div>
      <div className="get-verified popup-share fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md z-50">
        <div className="border-popup bg-white rounded-lg relative max-h-[90vh] overflow-y-auto">
          {/* Header */}
          <div className="flex justify-between p-4 pb-0">
            <div className="logo-popup flex items-center justify-center space-x-2 ">
              <img src={logo} alt="Pipaan Logo" className="w-24" />
            </div>
            <button onClick={onClose}>
              <img src={closeIcon} alt="close" className="w-8 h-8" />
            </button>
          </div>

          <div className="border-t-[#D9D9D9] border-t-2 mt-4">
            {paymentStatus === "success" || paymentStatus === "failed" ? (
              renderSuccessOrFailure()
            ) : (
              <div className="p-8">
                {/* Creator Info Header - Present in both steps */}
                <div className="w-full max-w-6xl mx-auto flex flex-col lg:flex-row gap-8 mb-8">
                  <div className="flex-1">
                    <div className="flex gap-4 items-center mb-6">
                      <img
                        src={
                          streamDetails?.user?.profile_picture_url ||
                          "https://placehold.co/100"
                        }
                        className="w-14 h-14 rounded-full border-2 border-[#BE1F2E] object-cover"
                        alt="Creator"
                      />
                      <div>
                        <h3 className="font-bold text-lg">
                          {streamDetails?.title || "Stream Title"}
                        </h3>
                        <div className="flex items-center gap-2 text-sm text-gray-500">
                          <span>
                            {formatDate(
                              streamDetails?.created_at || new Date(),
                            )}
                          </span>
                          <span className="flex items-center gap-1 text-green-700 font-medium">
                            <img
                              src={global}
                              alt="Public"
                              className="w-3 h-3"
                            />
                            Public
                          </span>
                        </div>
                        <p className="text-xs text-gray-400 mt-1">
                          Creator: {streamDetails?.user?.username || "Unknown"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="w-full max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8">
                  {/* Left Column */}
                  <div className="lg:col-span-2">
                    {/* Tab Switcher */}
                    <div className="flex gap-4 mb-6 border-b border-gray-200">
                      <button
                        className={`pb-2 px-4 font-medium transition-colors ${
                          activeTab === "donation"
                            ? "border-b-2 border-[#095228] text-[#095228]"
                            : "text-gray-500 hover:text-gray-700"
                        }`}
                        onClick={() => setActiveTab("donation")}
                      >
                        Send Money
                      </button>
                      <button
                        className={`pb-2 px-4 font-medium transition-colors ${
                          activeTab === "gift"
                            ? "border-b-2 border-[#095228] text-[#095228]"
                            : "text-gray-500 hover:text-gray-700"
                        }`}
                        onClick={() => setActiveTab("gift")}
                      >
                        Send Gift
                      </button>
                    </div>

                    {activeTab === "donation" ? (
                      step === 1 ? (
                        <div className="bg-[#F4F4F4] rounded-2xl p-6">
                          <div className="bg-white p-4 rounded-2xl mb-6">
                            <h3 className="font-semibold mb-3 text-[#000000] text-[16px]">
                              Choose Your Amount
                            </h3>
                            <div className="flex flex-wrap items-center gap-3">
                              {[10, 20, 30, 50].map((val) => (
                                <button
                                  key={val}
                                  onClick={() => handleAmountSelect(val)}
                                  // className="flex items-center text-[#000000] opacity-50 text-[18px] font-medium px-3 py-1 border border-[#FF7A51] gap-2 rounded-full h-fit self-center go-to-live-history-dollar"
                                  className={`flex items-center text-[#000000] text-[18px] font-medium px-3 py-1 border gap-2 rounded-full h-fit self-center go-to-live-history-dollar transition-all ${
                                    amount === val && !customAmount
                                      ? "border-[#FF7A51] opacity-100 bg-[#FF7A51]/10"
                                      : "border-gray-200 opacity-50 hover:border-[#FF7A51] hover:opacity-75"
                                  }`}
                                >
                                  <img
                                    src={dollar}
                                    alt="$"
                                    className="w-4 h-4 opacity-70"
                                  />
                                  {val}
                                </button>
                              ))}
                              {/* Custom Amount */}
                              <div
                                className={`flex items-center border-2 rounded-xl px-3 h-11 gap-2 ${
                                  customAmount
                                    ? "border-[#095228] bg-[#F3F8F5]"
                                    : "border-gray-200"
                                }`}
                              >
                                <span className="text-gray-500">$</span>
                                <input
                                  type="number"
                                  placeholder="Custom"
                                  value={customAmount}
                                  onChange={handleCustomAmountChange}
                                  className="w-24 outline-none bg-transparent"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        /* STEP 2: PAYMENT METHOD (Donation Only) */
                        <div className="space-y-6">
                          <div className="bg-[#F4F4F4] rounded-xl p-6">
                            <h3 className="font-semibold mb-4">
                              Payment Methods
                            </h3>

                            {/* Wallet Option */}
                            <div className="bg-white rounded-2xl p-6 flex items-center justify-between mb-4">
                              <div className="flex items-center gap-4">
                                <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
                                  <img
                                    src={sellericon}
                                    alt="Wallet"
                                    className="w-6 h-6"
                                  />
                                </div>
                                <div>
                                  <p className="text-sm text-gray-500">
                                    Wallet Balance
                                  </p>
                                  <p className="text-2xl font-bold">
                                    ${walletBalance}
                                  </p>
                                </div>
                              </div>
                              <button
                                onClick={() => setSelectedCard("wallet")}
                                className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                                  selectedCard === "wallet"
                                    ? "border-green-600"
                                    : "border-gray-300"
                                }`}
                              >
                                {selectedCard === "wallet" && (
                                  <div className="w-3 h-3 bg-green-600 rounded-full" />
                                )}
                              </button>
                            </div>

                            {/* Saved Cards */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                              {savedCards.map((card) => (
                                <div
                                  key={card.id}
                                  onClick={() => setSelectedCard(card.id)}
                                  className={`rounded-xl p-4 flex gap-3 cursor-pointer border-2 transition-all ${
                                    selectedCard === card.id
                                      ? "border-[#095228] bg-green-50"
                                      : "border-[#D9D9D9] bg-white"
                                  }`}
                                >
                                  <img
                                    src={card.img}
                                    alt={card.name}
                                    className="w-10 h-6 object-contain"
                                  />
                                  <div>
                                    <p className="font-medium text-sm">
                                      {card.name} {card.last4}
                                    </p>
                                    <p className="text-xs text-gray-500">
                                      Exp: {card.expiry}
                                    </p>
                                  </div>
                                </div>
                              ))}

                              {/* ✅ Add New Card Option */}
                              <div
                                onClick={() => setSelectedCard("new_card")}
                                className={`rounded-xl p-4 flex gap-3 cursor-pointer border-2 transition-all items-center justify-center border-dashed ${
                                  selectedCard === "new_card"
                                    ? "border-[#095228] bg-green-50"
                                    : "border-gray-400 bg-gray-50 hover:bg-gray-100"
                                }`}
                              >
                                <div className="flex flex-col items-center">
                                  <span className="text-xl font-bold text-gray-400">
                                    +
                                  </span>
                                  <p className="font-medium text-sm text-gray-600">
                                    Add New Card
                                  </p>
                                </div>
                              </div>
                            </div>

                            {/* ✅ Render Stripe Card Element if "new_card" selected */}
                            {selectedCard === "new_card" && (
                              <div className="mt-4 border border-green-400 rounded-xl px-4 py-3 bg-white">
                                <CardElement
                                  options={{
                                    style: {
                                      base: {
                                        fontSize: "16px",
                                        color: "#222",
                                        "::placeholder": { color: "#888" },
                                        fontFamily: "inherit",
                                      },
                                      invalid: { color: "#BE1F2E" },
                                    },
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      )
                    ) : (
                      /* GIFT SELECTION */
                      <div className="bg-[#F4F4F4] rounded-2xl p-6 min-h-[300px]">
                        <h3 className="font-semibold mb-4 text-[#000000] text-[16px]">
                          Select a Gift
                        </h3>
                        {gifts.length > 0 ? (
                          <div className="grid grid-cols-3 sm:grid-cols-4 gap-4">
                            {gifts.map((gift) => (
                              <button
                                key={gift.id}
                                onClick={() => setSelectedGift(gift)}
                                className={`flex flex-col items-center justify-center p-3 rounded-xl border-2 transition-all ${
                                  selectedGift?.id === gift.id
                                    ? "border-[#095228] bg-green-50 shadow-sm"
                                    : "border-transparent hover:bg-white hover:shadow-sm"
                                }`}
                              >
                                {gift.icon ? (
                                  <img
                                    src={gift.icon}
                                    alt={gift.name}
                                    className="w-12 h-12 mb-2 object-contain"
                                  />
                                ) : (
                                  <span className="text-4xl mb-2">
                                    {gift.emoji || "🎁"}
                                  </span>
                                )}
                                <span className="text-sm font-medium text-gray-800">
                                  {gift.name}
                                </span>
                                <span className="text-xs text-[#E8A317] font-bold flex items-center gap-1">
                                  🪙 {gift.cost || gift.coinValue}
                                </span>
                              </button>
                            ))}
                          </div>
                        ) : (
                          <div className="text-center text-gray-400 py-10">
                            Loading gifts...
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Right Column: Order Summary */}
                  <div className="h-fit">
                    <div className="bg-white border rounded-2xl p-6 shadow-sm">
                      <h3 className="text-lg font-semibold mb-4 text-[#000000]">
                        Order Summary
                      </h3>
                      <div className="space-y-3 text-sm">
                        <div className="flex justify-between">
                          <span className="text-gray-500 text-[16px]">
                            {activeTab === "donation"
                              ? "Subtotal"
                              : "Gift Cost"}
                          </span>
                          <span className="font-medium text-[16px]">
                            {activeTab === "donation"
                              ? `$${amount}`
                              : selectedGift
                                ? `🪙 ${
                                    selectedGift.cost || selectedGift.coinValue
                                  }`
                                : "-"}
                          </span>
                        </div>
                        {activeTab === "donation" && (
                          <div className="flex justify-between">
                            <span className="text-gray-500 text-[16px]">
                              Tax
                            </span>
                            <span className="font-medium text-[16px]">$0</span>
                          </div>
                        )}
                        <hr className="my-2" />
                        <div className="flex justify-between text-lg font-bold">
                          <span>Total</span>
                          <span>
                            {activeTab === "donation"
                              ? `$${amount}`
                              : selectedGift
                                ? `🪙 ${
                                    selectedGift.cost || selectedGift.coinValue
                                  }`
                                : "-"}
                          </span>
                        </div>
                      </div>

                      {activeTab === "donation" ? (
                        step === 1 ? (
                          <button
                            onClick={() => setStep(2)}
                            className="w-full mt-6 h-12 px-6 rounded-full bg-[#095228] text-white flex items-center justify-between hover:bg-green-900 transition"
                          >
                            <span>Donate</span>
                            <span className="text-xl">→</span>
                          </button>
                        ) : (
                          <button
                            onClick={handleDonate}
                            disabled={submitting}
                            className="w-full mt-6 h-12 px-6 rounded-full bg-[#095228] text-white flex items-center justify-center gap-2 hover:bg-green-900 transition disabled:opacity-50"
                          >
                            {submitting ? "Processing..." : "Pay Now"}
                            {!submitting && <span className="text-xl">→</span>}
                          </button>
                        )
                      ) : (
                        /* GIFT CONFIRM BUTTON */
                        <button
                          onClick={handleSendGift}
                          disabled={submitting || !selectedGift}
                          className="w-full mt-6 h-12 px-6 rounded-full bg-[#095228] text-white flex items-center justify-center gap-2 hover:bg-green-900 transition disabled:opacity-50 disabled:bg-gray-400"
                        >
                          {submitting ? "Sending..." : "Send Gift"}
                          {!submitting && <span className="text-xl">→</span>}
                        </button>
                      )}
                    </div>

                    <button
                      onClick={() => {
                        if (step === 2 && activeTab === "donation") setStep(1);
                        else onClose();
                      }}
                      className="w-full text-gray-500 text-sm hover:underline mt-4"
                    >
                      {step === 2 && activeTab === "donation"
                        ? "Go Back"
                        : "Cancel"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoLiveDonationgiftModal;
